import { render, staticRenderFns } from "./TestimonialsCarousel.vue?vue&type=template&id=ec6f8be8&"
import script from "./TestimonialsCarousel.vue?vue&type=script&lang=js&"
export * from "./TestimonialsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports